
// 'use client';

// import React, { useState } from "react";
// import { Link } from 'react-router-dom';
// import { Phone, Send } from "lucide-react";
// import securtechlogo11 from "../assests/tech/securtechlogo11.png";
// import InquiryPopup from "./main/InquiryPopup";

// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);

//   return (
//     <>
//       <section className="NavbarSection">
//         <div className="navbar-container">
//           <nav className="navbar-main">
//             {/* Logo */}
//             <div className="navbar-logo">
//               <img id="logoimage" src={securtechlogo11} alt="Logo" />
//               <span className="logo-blue">Secur</span>
//               <span className="logo-green">tech</span>
//               <span className="logo-in">Institute</span>
//             </div>

//             {/* Toggle (Hamburger) */}
//             <input
//               id="menu-toggle"
//               type="checkbox"
//               checked={menuOpen}
//               onChange={() => setMenuOpen(!menuOpen)}
//               className="hidden"
//             />
//             <label className="menu-toggle-btn md:hidden" htmlFor="menu-toggle">
//               <div className="menu-bar bar1"></div>
//               <div className="menu-bar bar2"></div>
//               <div className="menu-bar bar3"></div>
//             </label>

//             {/* Nav Links */}
//             <ul className={`navbar-links ${menuOpen ? "show" : ""}`}>
//               <li><Link to="/" className="active-link">Home</Link></li>
//               <li><Link to="/about">About Us</Link></li>
//               <li><Link to="/Courses">Courses ▾</Link></li>
//               <li><Link to="/Freelance">Freelance</Link></li>
//               <li><Link to="/Contact">Contact</Link></li>

//               {/* New Modern Buttons */}
//               <div className="navbar-buttons">
//                 <button
//                   className="Btn inquire-button"
//                   onClick={() => setShowPopup(true)}
//                 >
//                   <span className="svgContainer">
//                     <Send size={18} color="#fff" />
//                     <span style={{ marginLeft: "6px", color: "#fff" }}>Inquire</span>
//                   </span>
//                 </button>
//                 {showPopup && <InquiryPopup onClose={() => setShowPopup(false)} />}
//               </div>
//             </ul>
//           </nav>

//           {/* Mobile overlay */}
//           {menuOpen && (
//             <div className="menu-overlay" onClick={() => setMenuOpen(false)}></div>
//           )}

//           {/* Styles */}
//           <style>{` @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

//         body {
//           font-family: 'Inter', sans-serif;
//           margin: 0;
//           padding: 0;
//           background-color: #6b1e6e;
//         }

// .NavbarSection{
// display: flex;
// jus
// }

// #logoimage{
// width: 200px;
// height:100px;
//     object-fit: contain;
// }
//         .navbar-container {
//           width: 100%;
//           background-color: #6b1e6e;
//           box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//         }

//         .navbar-main {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           // padding: 1rem 2rem;
//           margin: 0 auto;
//         }

//        .navbar-logo {
//     font-size: 1.5rem;
//     font-weight: 700;
//     display: flex;
//     /* justify-Content: center; */
//     justify-content: center;
//     align-items: center;
// }
//         .navbar-logo .logo-blue,
//         .navbar-logo .logo-green {
//           color: #39ff14;
//         }


//         .logo-in{
// font-size:24px;
// color:#fff;
// margin: 10px;
// font-family: inter;
//         }
//         .navbar-links {
//           display: flex;
//           align-items: center;
//           list-style: none;
//           gap: 1.5rem;
//           margin: 0;
//           padding: 0;
//         }

//         .navbar-links li a {
//           color: #F5F5DC;
//           text-decoration: none;
//           font-weight: 500;
//           transition: color 0.3s ease;
//         }

//         .navbar-links li a:hover,
//         .navbar-links li a.active-link {
//           color: #f8f8f2ff;
//         }

//         .navbar-buttons {
//           display: flex;
//           gap: 1rem;
//         }

//         /* Circular Green Phone Button */
//         .phone-button {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           width: 45px;
//           height: 45px;
//           border-radius: 100%;
//           border: none;
//           background-color: #30C04F;
//           transition: background-color 0.3s ease;
//         }

//         .phone-button:hover {
//           background-color: #2bac47;
//         }

//         /* Glass Blur Inquire Button */
//         .Btn {
//           height: 45px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border: none;
//           background-color: transparent;
//           position: relative;
//           padding: 0 18px;
//           border-radius: 8px;
//           cursor: pointer;
//           transition: all 0.3s;
//           overflow: hidden;
//           text-decoration: none;
//         }

//         .svgContainer {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background-color: transparent;
//           backdrop-filter: blur(0px);
//           border-radius: 8px;
//           transition: all 0.3s;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           padding: 0.5rem 1rem;
//           font-weight: 600;
//         }

//         .BG {
//           position: absolute;
//           content: "";
//           width: 100%;
//           height: 100%;
//           background: #181818;
//           z-index: -1;
//           border-radius: 10px;
//           pointer-events: none;
//           transition: all 0.3s;
//         }

//         .Btn:hover .BG {
//           transform: rotate(35deg);
//           transform-origin: bottom;
//         }

//         .Btn:hover .svgContainer {
//           background-color: rgba(255, 255, 255, 0.1);
//           backdrop-filter: blur(4px);
//         }

//         /* Hamburger Menu */
//         .menu-toggle-btn {
//           display: none;
//           cursor: pointer;
//           width: 30px;
//           height: 22px;
//           position: relative;
//         }

//         #menu-toggle {
//           display: none;
//         }

//         .menu-bar {
//           width: 100%;
//           height: 3px;
//           background-color: #fcf9f9ff;
//           border-radius: 5px;
//           transition: all 0.3s ease;
//           position: absolute;
//           left: 0;
//         }

//         .bar1 { top: 0; }
//         .bar2 { top: 9px; }
//         .bar3 { top: 18px; }

//         #menu-toggle:checked ~ .menu-toggle-btn .bar1 {
//           transform: rotate(45deg);
//           top: 9px;
//         }

//         #menu-toggle:checked ~ .menu-toggle-btn .bar2 {
//           opacity: 0;
//         }

//         #menu-toggle:checked ~ .menu-toggle-btn .bar3 {
//           transform: rotate(-45deg);
//           top: 9px;
//         }

//         .menu-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: rgba(0, 0, 0, 0.4);
//           backdrop-filter: blur(2px);
//           z-index: 999;
//         }

//         @media (max-width: 768px) {
//           .navbar-main {
//             padding: 1rem 1.5rem;
//           }

//           .menu-toggle-btn {
//             display: block;
//             z-index: 1001;
//           }

//           .navbar-links {
//             position: fixed;
//             top: 0;
//             right: 0;
//             flex-direction: column;
//             align-items: flex-start;
//             justify-content: flex-start;
//             width: 75%;
//             max-width: 300px;
//             height: 100vh;
//             background-color: #6b1e6e;
//             padding: 2rem;
//             box-shadow: -4px 0 10px rgba(0, 0, 0, 0.1);
//             transform: translateX(100%);
//             transition: transform 0.4s ease-in-out;
//             z-index: 1000;
//           }

//           .navbar-links.show {
//             transform: translateX(0);
//           }

//           .navbar-links li {
//             width: 100%;
//             margin: 0;
//           }

//           .navbar-links li a {
//             display: block;
//             font-size: 1.1rem;
//             padding: 1rem 0;
//             border-bottom: 1px solid #f0f0f0;
//           }

//           .navbar-buttons {
//             flex-direction: column;
//             gap: 1rem;
//             margin-top: 2rem;
//           }
//         }

//          @media (min-width: 769px) {
//            .navbar-buttons {
//              display: flex;
//          }
//         }
// @media (min-width: 300px) and (max-width: 480px) {
//  #logoimage {
//         width: 145px;
//         height: 39px;
//         object-fit: contain;
//     }
// }
//     @media (min-width: 769px) and (max-width: 1024px) {
// #logoimage{
//   width: 120px;
//   height: 60px;
//   object-fit: contain;
// }
//   .logo-in{
//           display: none;
//   }
//           .navbar-links{
//           gap:12px;
//           }
//       }

// `}</style>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Navbar;

'use client';

import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Phone, Send } from "lucide-react";
import securtechlogo11 from "../assests/tech/securtechlogo11.png";
import InquiryPopup from "./main/InquiryPopup";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <section className="NavbarSection">
        <div className="navbar-container">
          <nav className="navbar-main">

            {/* Logo */}
            <div className="navbar-logo">
              <img id="logoimage" src={securtechlogo11} alt="Logo" />
              <span className="logo-blue">Secur</span>
              <span className="logo-green">tech</span>
              <span className="logo-in">Institute</span>
            </div>

            {/* Hamburger Toggle */}
            <input
              id="menu-toggle"
              type="checkbox"
              checked={menuOpen}
              onChange={() => setMenuOpen(!menuOpen)}
              className="hidden"
            />
            <label className="menu-toggle-btn md:hidden" htmlFor="menu-toggle">
              <div className="menu-bar bar1"></div>
              <div className="menu-bar bar2"></div>
              <div className="menu-bar bar3"></div>
            </label>

            {/* Menu Links */}
            <ul className={`navbar-links ${menuOpen ? "show" : ""}`}>

              <li>
                <Link to="/" className="active-link" onClick={closeMenu}>
                  Home
                </Link>
              </li>

              <li>
                <Link to="/about" onClick={closeMenu}>
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/Courses" onClick={closeMenu}>
                  Courses ▾
                </Link>
              </li>

              <li>
                <Link to="/Freelance" onClick={closeMenu}>
                  Freelance
                </Link>
              </li>

              <li>
                <Link to="/Contact" onClick={closeMenu}>
                  Contact
                </Link>
              </li>

              {/* Buttons */}
              <div className="navbar-buttons">
                <button
                  className="Btn inquire-button"
                  onClick={() => {
                    setShowPopup(true);
                    closeMenu();
                  }}
                >
                  <span className="svgContainer">
                    <Send size={18} color="#fff" />
                    <span style={{ marginLeft: "6px", color: "#fff" }}>
                      Inquire
                    </span>
                  </span>
                </button>

                {showPopup && (
                  <InquiryPopup onClose={() => setShowPopup(false)} />
                )}
              </div>
            </ul>
          </nav>

          {/* BACKDROP OVERLAY FOR MOBILE */}
          {menuOpen && (
            <div
              className="menu-overlay"
              onClick={closeMenu}
            ></div>
          )}

          {/* Styles */}
          <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

            body {
              font-family: 'Inter', sans-serif;
              margin: 0;
              padding: 0;
              background-color: #6b1e6e;
            }

          
.NavbarSection{
display: flex;
jus
}

#logoimage{
width: 200px;
height:100px;
    object-fit: contain;
}
        .navbar-container {
          width: 100%;
          background-color: #6b1e6e;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          position: sticky;
          top: 0;
          z-index: 1000;
        }

        .navbar-main {
          display: flex;
          justify-content: space-between;
          align-items: center;
          // padding: 1rem 2rem;
          margin: 0 auto;
        }

       .navbar-logo {
    font-size: 1.5rem;
    font-weight: 700;
    display: flex;
    /* justify-Content: center; */
    justify-content: center;
    align-items: center;
}
        .navbar-logo .logo-blue,
        .navbar-logo .logo-green {
          color: #39ff14;
        }


        .logo-in{
font-size:24px;
color:#fff;
margin: 10px;
font-family: inter;
        }
        .navbar-links {
          display: flex;
          align-items: center;
          list-style: none;
          gap: 1.5rem;
          margin: 0;
          padding: 0;
        }

        .navbar-links li a {
          color: #F5F5DC;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        .navbar-links li a:hover,
        .navbar-links li a.active-link {
          color: #f8f8f2ff;
        }

        .navbar-buttons {
          display: flex;
          gap: 1rem;
        }

        /* Circular Green Phone Button */
        .phone-button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 45px;
          height: 45px;
          border-radius: 100%;
          border: none;
          background-color: #30C04F;
          transition: background-color 0.3s ease;
        }

        .phone-button:hover {
          background-color: #2bac47;
        }

        /* Glass Blur Inquire Button */
        .Btn {
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: none;
          background-color: transparent;
          position: relative;
          padding: 0 18px;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          overflow: hidden;
          text-decoration: none;
        }

        .svgContainer {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: transparent;
          backdrop-filter: blur(0px);
          border-radius: 8px;
          transition: all 0.3s;
          border: 1px solid rgba(255, 255, 255, 0.2);
          padding: 0.5rem 1rem;
          font-weight: 600;
        }

        .BG {
          position: absolute;
          content: "";
          width: 100%;
          height: 100%;
          background: #181818;
          z-index: -1;
          border-radius: 10px;
          pointer-events: none;
          transition: all 0.3s;
        }

        .Btn:hover .BG {
          transform: rotate(35deg);
          transform-origin: bottom;
        }

        .Btn:hover .svgContainer {
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(4px);
        }

        /* Hamburger Menu */
        .menu-toggle-btn {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 22px;
          position: relative;
        }

        #menu-toggle {
          display: none;
        }

        .menu-bar {
          width: 100%;
          height: 3px;
          background-color: #fcf9f9ff;
          border-radius: 5px;
          transition: all 0.3s ease;
          position: absolute;
          left: 0;
        }

        .bar1 { top: 0; }
        .bar2 { top: 9px; }
        .bar3 { top: 18px; }

        #menu-toggle:checked ~ .menu-toggle-btn .bar1 {
          transform: rotate(45deg);
          top: 9px;
        }

        #menu-toggle:checked ~ .menu-toggle-btn .bar2 {
          opacity: 0;
        }

        #menu-toggle:checked ~ .menu-toggle-btn .bar3 {
          transform: rotate(-45deg);
          top: 9px;
        }

        .menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          backdrop-filter: blur(2px);
          z-index: 999;
        }

        @media (max-width: 768px) {
          .navbar-main {
            padding: 1rem 1.5rem;
          }

          .menu-toggle-btn {
            display: block;
            z-index: 1001;
          }

          .navbar-links {
            position: fixed;
            top: 0;
            right: 0;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 75%;
            max-width: 300px;
            height: 100vh;
            background-color: #6b1e6e;
            padding: 2rem;
            box-shadow: -4px 0 10px rgba(0, 0, 0, 0.1);
            transform: translateX(100%);
            transition: transform 0.4s ease-in-out;
            z-index: 1000;
          }

          .navbar-links.show {
            transform: translateX(0);
          }

          .navbar-links li {
            width: 100%;
            margin: 0;
          }

          .navbar-links li a {
            display: block;
            font-size: 1.1rem;
            padding: 1rem 0;
            border-bottom: 1px solid #f0f0f0;
          }

          .navbar-buttons {
            flex-direction: column;
            gap: 1rem;
            margin-top: 2rem;
          }
        }

         @media (min-width: 769px) {
           .navbar-buttons {
             display: flex;
         }
        }
@media (min-width: 300px) and (max-width: 480px) {
 #logoimage {
        width: 145px;
        height: 39px;
        object-fit: contain;
    }
}
    @media (min-width: 769px) and (max-width: 1024px) {
#logoimage{
  width: 120px;
  height: 60px;
  object-fit: contain;
}
  .logo-in{
          display: none;
  }
          .navbar-links{
          gap:12px;
          }
      }


          `}</style>
        </div>
      </section>
    </>
  );
};

export default Navbar;

